import { render } from "./TvmFeedBack.vue?vue&type=template&id=46863523&scoped=true"
import script from "./TvmFeedBack.vue?vue&type=script&lang=js"
export * from "./TvmFeedBack.vue?vue&type=script&lang=js"

import "./TvmFeedBack.vue?vue&type=style&index=0&id=46863523&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46863523"]])

export default __exports__